import React from 'react';
import { GlobalConfiguration } from '../../../models/GlobalConfiguration';
import StyledFieldDescription from '../../styles/StyledFieldDescription';
import { StyledInput } from '../../styles/StyledInputs';
import StyledSection from '../../styles/StyledSection';
import { StyledFieldRow, StyledHeading, StyledLabel } from '../../styles/styles';
import ConfigFieldLabel from './ConfigFieldLabel';
import { GLOBAL_CONFIG_FIELD_LABELS, MOBILE_APP_FIELDS } from './globalConfigFieldConfig';

type MobileAppSectionProps = {
  config: GlobalConfiguration;
  dirtyFields: Set<string>;
  onChange: (field: string, value: unknown) => void;
};

export default function MobileAppSection({ config, dirtyFields, onChange }: MobileAppSectionProps) {
  return (
    <StyledSection tone="tone1">
      <StyledHeading tone="tone1" headerVariant="heading2">
        Mobile App
      </StyledHeading>
      <StyledFieldDescription stacked>
        Installed apps older than the minimum show an &quot;Update required&quot; screen with a link
        to the store, and cannot be used until updated. Only raise it for a store release the old
        version cannot work without, and only once that release is live in the store (Android:
        rollout at 100%). Leave blank for no minimum.
      </StyledFieldDescription>
      {MOBILE_APP_FIELDS.map((fieldKey) => (
        <StyledFieldRow stacked sx={{ mb: 2 }} key={fieldKey} data-field={fieldKey}>
          <StyledLabel stacked>
            <ConfigFieldLabel
              fieldKey={fieldKey}
              label={GLOBAL_CONFIG_FIELD_LABELS[fieldKey]}
              dirtyFields={dirtyFields}
            />
          </StyledLabel>
          <StyledInput
            value={config[fieldKey] ?? ''}
            onChange={(e) => onChange(fieldKey, e.target.value)}
            placeholder="e.g. 1.0.10"
            inputProps={{ 'aria-label': GLOBAL_CONFIG_FIELD_LABELS[fieldKey] }}
          />
        </StyledFieldRow>
      ))}
    </StyledSection>
  );
}
